var pie = {
    type: 'pie',
    theme: 'calcite',
    innerRadius: '0%',
    startDuration: 0,
    graphs: [{}],
    groupPercent: 5,
    balloon: {
        fixedPosition: true
    },
    legend: {
        enabled: false
    },
    export: {
        enabled: true
    }
};
export default pie;
//# sourceMappingURL=pie.js.map